// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"4c8483a6","537":"9736072a","787":"99954036","964":"90d36315"}[chunkId] + ".chunk.js";
};